module.exports = __webpack_public_path__ + "media/images/pcb_noon-d6974dab.svg";